export type TMenu = {
  id: number | string;
  level: number | string;
  title: string;
  url: string;
  text: string;
  img: string | null;
  is_parent?: boolean;
  children?: TMenu[];
};
